//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { EventsNames } from '../../../../helpers/events-names'
import { CreateEditPopupOptions } from '../../../common/create-edit-popup/create-edit-popup.directive'
import { CommonHelper } from '../../../../helpers/common-helper'
import { Enums } from '../../../../models/common/enums'
import { IOpObject } from '../../../../models/util/interfaces'
import { TypeHelper } from '../../../../helpers/type-helper'
import { OpValidateInfo } from '../../../../models/custom/op-validate-info'
import { LocationHelper } from '../../locations.helper'
import { LocationService } from '../../../../services/location'
import { OpLocation, OpDevice, OpMeter, OpDataTypeInGroup, OpActionType, OpData, OpActionData } from '../../../../models/core'
import { LocalizationHelper, Dictionary, LogHelper, ToastHelper, ConvertHelper } from '../../../../helpers'
import { ConfirmationSource } from '../../../common/confirmation-popup/confirmation-popup.directive'
import { InfoPopupSource } from '../../../common/info-popup/info-popup.directive'
import { SourcePopover } from '../../../common/select-box-popup/select-box-popup.directive'
import { CreateEditSection } from '../../../common/common.create-edit'
import { SESSION } from '../../../../models/custom'
import { CorrespondingActionTypeModel } from '../../../api/api.models'
import { CreateEditController, CreateEditScope } from '../../../common/common.create-edit.controller'
import { UserSessionService } from '../../../../services/user-session'
import { ActionService } from '../../../../services/action'
import { MeterService } from '../../../../services/meter'
import { DeviceService } from '../../../../services/device'
import { KingspanConfigurationFormService } from '../service'
import { KingspanCreateEditInitparams } from '../kingspan-configuration-form.interfaces'

interface KingspanCreateEditScope extends CreateEditScope {
    options: CreateEditPopupOptions

    confirmSaveLocationSource: ConfirmationSource
    warningId: number
    needInfoPopup: boolean
    infoPopupSource: InfoPopupSource
    actionsId: number
    confirmSendActionsSource: ConfirmationSource

    confirmChangesText: string
    noText: string

    needActionRun: boolean
}

const SMART_SERV_PRO_CONFIGURATION_NAME: string = 'SMART_SERV_PRO_CONFIGURATION'
const OPEN_POPUP_EVENT_NAME: string = `${Enums.SimaxDedicatedCreateEditForm.KINGSPAN.replace(/-/gi, '_').toUpperCase()}_OPEN_POPUP`

export class KingspanCreateEditController
    extends CreateEditController {

    // Consts

    private static get LOG_STRING(): string { return '[SIMAX.Location.KingspanLocationCreateEditDirective] - %s' }

    // Consts End

    // Members

    private referenceValue: OpLocation;

    private deferForSaving: ng.IDeferred<IOpObject> = null
    private objectToSave: OpLocation
    private deviceToSave: OpDevice

    private submitDeviceDefer: ng.IDeferred<OpDevice>
    private isDeviceValid: boolean

    private needHideLoadingIndicator: boolean

    private deferrs: ng.IPromise<OpDevice>[] = []

    // Members End

    constructor(
        private $scope: KingspanCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        protected userSession: UserSessionService,
        public referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName,
        private locationService: LocationService,
        private actionService: ActionService,
        private meterService: MeterService,
        private deviceService: DeviceService,
        private kingspanService: KingspanConfigurationFormService
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }

    // Events        

    private onInit(args: any[]): void {
        if (_.size(args) > 0) {
            const createEditInitParams: KingspanCreateEditInitparams = args[0]

            if (createEditInitParams.isCopy === true) {
                createEditInitParams.referenceObjectId = 0
                if (createEditInitParams.referenceObject != null) {
                    createEditInitParams.referenceObject.idObject = 0
                    const location: OpLocation = createEditInitParams.referenceObject as OpLocation
                    location.currentDevices = []
                    location.currentDevicesDict = null
                    location.currentMeters = []
                    location.currentMetersDict = null
                }
            }

            this.referenceValue = createEditInitParams ? <OpLocation>createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP)

            if (this.referenceValue != null && this.referenceValue.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, LocationService.SIMAX_MODULE_NAME)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, LocationService.SIMAX_MODULE_NAME)
            }

            createEditInitParams.onRunAction = (opDevice: OpDevice): void => { this.onRunAction(opDevice) }

            const formSection: CreateEditSection = _.find(createEditInitParams.sections, (section: CreateEditSection) => section.type === 'form')

            const dataTypePromise: JQueryDeferred<void> = $.Deferred<void>()
            if (formSection != null) {
                formSection.dataTypesToEdit = formSection.dataTypesToEdit.filter((dataType: OpDataTypeInGroup) => {
                    return !this.kingspanService.getKingspanDedicatedFormDataTypesList().some((idDataType: number) => dataType.idDataType === idDataType)
                })
                createEditInitParams.sections = [formSection]
                dataTypePromise.resolve()
            } else {
                createEditInitParams.sections = []
                dataTypePromise.resolve()
            }

            dataTypePromise.then(() => {
                this.deferrs = []

                this.submitDeviceDefer = this.$q.defer<OpDevice>();

                createEditInitParams.onSubmitDevice = (opDevice: OpDevice): ng.IPromise<OpDevice> => this.onSubmitDevice(opDevice)
                createEditInitParams.onValidateDevice = (valid: boolean): void => this.onValidateDevice(valid)
                this.deferrs.push(this.submitDeviceDefer.promise)

                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP_KINGSPAN, createEditInitParams)
            })
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const defer: ng.IDeferred<IOpObject> = this.$q.defer()

        this.$scope.$root.$broadcast(EventsNames.SUBMIT_LOCATION_CONFIGURATION_KINGSPAN)

        if (!this.isDeviceValid) {
            ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IncorrectData))

            return this.$q.reject(null)
        }

        return this.$q.all([this.submitDeviceDefer.promise])
            .then((result: OpDevice[]) => {
                const opDeviceToSave: OpDevice = result[0]

                const locationToSave: OpLocation = objectToSave as OpLocation

                if (this.referenceValue != null) {
                    locationToSave.currentDevices = this.referenceValue.currentDevices
                    locationToSave.currentDevicesDict = this.referenceValue.currentDevicesDict
                    locationToSave.currentMeters = this.referenceValue.currentMeters
                    locationToSave.currentMetersDict = this.referenceValue.currentMetersDict
                }

                if (this.referenceValue != null && opDeviceToSave != null && this.referenceValue.currentDevices.some((device: OpDevice) => device.serialNbr == opDeviceToSave.serialNbr) === false || opDeviceToSave == null) {
                    //device was changed. need to assign old device to some depository

                    if (opDeviceToSave == null) { //device removed from existed location
                        if (this.referenceValue && _.size(this.referenceValue.currentDevices) > 0) {
                            this.callDepositoryListPopup(opDeviceToSave, locationToSave)
                        } else {
                            return this.prepareForSavingKingspan(opDeviceToSave, locationToSave)
                        }
                    } else {
                        if (this.referenceValue.currentDevices.length > 0) {
                            this.callDepositoryListPopup(opDeviceToSave, locationToSave)
                        } else {
                            return this.prepareForSavingKingspan(opDeviceToSave, locationToSave)
                        }
                    }
                    this.needHideLoadingIndicator = true
                    defer.resolve(null)
                } else {
                    return this.prepareForSavingKingspan(opDeviceToSave, locationToSave)
                }

                return defer.promise
            })
    }

    private onRunAction(opDevice: OpDevice): void {
        this.deviceToSave = opDevice
        this.askRunAction()
    }

    private onSubmitDevice(opDevice: OpDevice): ng.IPromise<OpDevice> {
        this.submitDeviceDefer.resolve(opDevice)
        return this.submitDeviceDefer.promise
    }

    private onValidateDevice(isValid): void {
        this.isDeviceValid = isValid
    }

    // Events End

    // Setup

    private setEvents(): void {
        this.$scope.$on(
            OPEN_POPUP_EVENT_NAME,
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )
    }

    private setOptions(): void {
        this.$scope.noText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.No)
        this.$scope.confirmChangesText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm)

        this.$scope.options = {
            onSubmit: null,
            onClose: null,
            referenceType: LocationService.REFERENCE_TYPE,
            submitBulkEdit: null,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, LocationService.SIMAX_MODULE_NAME),
            title: '',
            type: null,

            onBulkSave: null,
            onSave: (objectToSave: IOpObject): ng.IPromise<IOpObject> => this.onSave(objectToSave),
        }

        this.$scope.warningId = new Date().getTime() + new Date().getTime()
        this.$scope.confirmSaveLocationSource = {
            confirmYes: () => {
                this.$scope.$root.$broadcast(EventsNames.SHOW_LOADING_INDICATOR)
                this.addMeterAndSaveLocation(this.objectToSave, this.deviceToSave, this.deferForSaving)
                    .then(() => {
                        this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                    })
            },
            confirmNo: () => {
                this.deferForSaving.reject()
            }
        }

        this.$scope.actionsId = new Date().getTime() + Math.floor(Math.random() * new Date().getTime())
        this.$scope.confirmSendActionsSource = {
            confirmYes: () => {
                this.runAction()
            },
            confirmNo: () => { }
        }
    }

    // Setup End

    //#region Custom methods

    private runAction(): void {
        this.actionService
            .getCorrespondingActionType([this.deviceToSave.serialNbr], Enums.ReferenceType.SerialNbr)
            .then((actionTypes: OpActionType[]) => {
                const action: OpActionType = _.find(actionTypes, (item: OpActionType) => item.name === SMART_SERV_PRO_CONFIGURATION_NAME)
                if (action != null) {

                    this.actionService
                        .getActionParameters(action.idActionType, Enums.ReferenceType.SerialNbr, [this.deviceToSave.serialNbr])
                        .then((actionData: OpActionData[]) => {

                            const actionSaveModel: CorrespondingActionTypeModel = new CorrespondingActionTypeModel()
                            actionSaveModel.id = action.idActionType
                            actionSaveModel.type = Enums.ReferenceType.SerialNbr
                            actionSaveModel.referenceValues = [this.deviceToSave.serialNbr]
                            actionSaveModel.isActionDataFixed = false
                            actionSaveModel.fields = actionData.map((data: OpActionData) => {
                                const _data: OpData = _.find(this.deviceToSave.dataList.toArray(), (item: OpData) => item.idDataType === data.idDataType)
                                if (_data != null) {
                                    data.value = _data.value
                                }

                                return <any>{
                                    idDataType: data.idDataType,
                                    typeId: data.dataType.idDataTypeClass,
                                    index: data.indexNbr,
                                    value: _data != null ? _data.value : data.value
                                }
                            })

                            this.actionService.runAction(this.$scope, actionSaveModel, this.$scope.warningId)

                        })
                } else {
                    ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoActionToSend))
                }
            })
            .fail((error: any) => {
                let errorMsg: string = error

                if (SESSION.isType(error)) {
                    errorMsg = (<SESSION>error).toString()
                }
            })
            .always(() => {
                this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
            })
    }

    private askRunAction(): void {
        this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.actionsId, `${LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendActionToDevice)} ${this.deviceToSave.serialNbr}?`)
    }

    private saveLocation(objectToSave: IOpObject, defer: ng.IDeferred<IOpObject> = null, fromIOpObject: boolean = true): ng.IPromise<IOpObject> {
        const deferred: ng.IDeferred<IOpObject> = defer || this.$q.defer<IOpObject>()
        this.locationService
            .saveLocation(fromIOpObject ? OpLocation.fromIOpObject(objectToSave) : <OpLocation>objectToSave, this.moduleName)
            .then((savedObject: OpLocation) => {
                CommonHelper.setValueToLocalStorage(CommonHelper.localStorageVarForSavedEntity.locationSaved, true, 0)
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                LogHelper.error(KingspanCreateEditController.LOG_STRING, error)
                this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                deferred.reject(error)
            })
        return deferred.promise
    }

    private prepareForSavingKingspan(opDevice: OpDevice, locationToSave: OpLocation, depositoryLocationId: number = null): ng.IPromise<IOpObject> {
        const defer: ng.IDeferred<IOpObject> = this.$q.defer()

        if (depositoryLocationId != null) {
            if (opDevice != null) {
                if (_.size(locationToSave.currentDevices) > 0) {
                    locationToSave.currentDevices.forEach((device: OpDevice) => {
                        if (opDevice.serialNbr === device.serialNbr) {
                            device.opState = Enums.OpChangeState.Modified
                            this.assignDeviceToLocation(device, locationToSave.idLocation)
                        } else {
                            device.opState = Enums.OpChangeState.Delete
                            this.assignDeviceToLocation(device, depositoryLocationId)
                        }
                    })
                    if (!_.find(locationToSave.currentDevices, (device: OpDevice) => device.serialNbr === opDevice.serialNbr)) {
                        opDevice.opState = Enums.OpChangeState.New
                        this.assignDeviceToLocation(opDevice, locationToSave.idLocation)
                        locationToSave.currentDevices.push(opDevice)
                    }
                } else {
                    opDevice.opState = Enums.OpChangeState.New
                    this.assignDeviceToLocation(opDevice, locationToSave.idLocation)
                    locationToSave.currentDevices.push(opDevice)
                }
            } else {
                locationToSave.currentDevices.forEach((device: OpDevice) => {
                    device.opState = Enums.OpChangeState.Delete
                    this.assignDeviceToLocation(device, depositoryLocationId)
                })
            }
        } else {
            if (opDevice != null) {
                if (!_.find(locationToSave.currentDevices, (device: OpDevice) => device.serialNbr === opDevice.serialNbr)) {
                    opDevice.opState = Enums.OpChangeState.New
                    this.assignDeviceToLocation(opDevice, locationToSave.idLocation)
                    locationToSave.currentDevices.push(opDevice)
                }
            }
        }

        locationToSave.currentMeters.forEach((meter: OpMeter) => {
            locationToSave.currentDevices.forEach((device: OpDevice) => {
                if (device.opState === Enums.OpChangeState.Delete) {
                    const idMeter: number = device.dataList.getValue(Enums.DataType.HELPER_ID_METER)
                    if (idMeter == meter.idMeter) {
                        const dev: OpDevice = new OpDevice(null)
                        dev.serialNbr = device.serialNbr
                        dev.opState = Enums.OpChangeState.Modified

                        meter.currentDevices = [dev]

                        const currentLocation: OpLocation = _.first(device.currentLocations)
                        if (currentLocation != null) {
                            const loc: OpLocation = new OpLocation(null)
                            loc.idLocation = currentLocation.idLocation
                            loc.opState = Enums.OpChangeState.Modified

                            meter.currentLocations = [loc]
                        }
                    }
                }
            })
        })

        defer.resolve(this.saveKingspan(locationToSave, opDevice))

        return defer.promise
    }

    private saveKingspan(locationToSave: OpLocation, opDevice: OpDevice): ng.IPromise<IOpObject> {
        const defer: ng.IDeferred<IOpObject> = this.$q.defer()

        this.$scope.needInfoPopup = false

        LocationHelper
            .validateLocations(this.userSession.getDataProvider(), [locationToSave])
            .then((validateInfos: OpValidateInfo[]) => {
                const validateInfo: OpValidateInfo = validateInfos[0]

                this.deviceToSave = opDevice

                if (validateInfo.Status === Enums.ValidationStatus.Correct) {
                    this.addMeterAndSaveLocation(locationToSave, opDevice, defer)
                } else {
                    const errorMsg: string = validateInfo.Message.join(TypeHelper.HTMLNewLine)

                    if (this.needHideLoadingIndicator == true) {
                        this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                    }

                    if (validateInfo.Status === Enums.ValidationStatus.Warning) {

                        this.deferForSaving = this.$q.defer()
                        this.objectToSave = locationToSave

                        this.$timeout(() => {
                            this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.warningId, errorMsg)
                        })

                        defer.reject(this.deferForSaving)
                    } else {
                        this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                        this.$scope.needInfoPopup = true
                        this.$scope.infoPopupSource = {
                            infoText: errorMsg,
                            popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Warning)
                        }

                        this.$timeout(() => {
                            this.$scope.$root.$broadcast(EventsNames.OPEN_INFO_POPUP_POPUP + this.$scope.warningId, [])
                        }, 100)

                        defer.reject()
                    }
                }

                this.needHideLoadingIndicator = false
            })
            .fail(() => {
                defer.reject()
            })

        return defer.promise;
    }

    private assignDeviceToLocation(device: OpDevice, idLocationToAssign: number): void {
        const opLocation: OpLocation = new OpLocation(null)
        opLocation.idLocation = idLocationToAssign
        opLocation.opState = Enums.OpChangeState.Loaded

        device.currentLocations = []
        device.currentLocations.push(opLocation)

        device.currentLocationsDict = new Dictionary<OpLocation>([])
        device.currentLocations.forEach((loc: OpLocation) => {
            device.currentLocationsDict.add(loc.idLocation, loc)
        })

        if (device.opState == Enums.OpChangeState.Delete) {
            const idMeter: number = device.dataList.getValue(Enums.DataType.HELPER_ID_METER)
            if (idMeter != null) {
                const meter: OpMeter = new OpMeter(null)
                meter.idMeter = idMeter
                meter.opState = Enums.OpChangeState.Modified

                const dev: OpDevice = new OpDevice(null)
                dev.serialNbr = device.serialNbr
                dev.opState = Enums.OpChangeState.Modified

                meter.currentDevices = [dev]
                meter.currentLocations = [opLocation]

                device.currentMeters = [meter]
            }
        } else {
            device.currentMeters.forEach((meter: OpMeter) => {
                const metDevice: OpDevice = new OpDevice(null)
                metDevice.serialNbr = device.serialNbr
                metDevice.opState = Enums.OpChangeState.New

                meter.currentDevices = [metDevice]
                meter.currentDevicesDict = new Dictionary<OpDevice>([])
                meter.currentDevicesDict.add(metDevice.serialNbr, metDevice)

                meter.currentLocations = [opLocation]
                meter.currentLocationsDict = new Dictionary<OpLocation>([])
                meter.currentLocationsDict.add(opLocation.idLocation, opLocation)
            })
        }
    }

    private callDepositoryListPopup(opDeviceToSave: OpDevice, locationToSave: OpLocation): void {

        const selectPopoverSource: SourcePopover = {
            popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SelectDepositoryToAssign),
            onSubmit: (id: number) => {
                this.$scope.$root.$broadcast(EventsNames.SHOW_LOADING_INDICATOR)
                return this.prepareForSavingKingspan(opDeviceToSave, locationToSave, id)
                    .then((savedLocation: IOpObject) => {
                        this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                        return savedLocation
                    })
            },
            selectPopoverSource: {
                dataTypeId: CommonHelper.depositoryColumnId,
                referenceTypeId: CommonHelper.IdLocation,
                selectedId: 0,
                dataIdSourceModule: Enums.WebSimaxModule.Depositories,
            },
            nothingSelectedMsg: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DepositoryNothingSelected)
        }

        this.$scope.$broadcast(EventsNames.OPEN_SELECT_POPOVER_POPUP + this.$scope.warningId, selectPopoverSource)
    }

    private addMeterAndSaveLocation(locationToSave: OpLocation, opDevice: OpDevice, defer: ng.IDeferred<IOpObject>) {
        const promise: JQueryDeferred<void> = $.Deferred<void>()

        if (opDevice != null && _.size(opDevice.currentMeters) === 0) {
            const opMeter: OpMeter = new OpMeter(null)

            opMeter.opState = Enums.OpChangeState.New
            opMeter.idMeterType = Enums.MeterType.SMART_SERV_PRO
            opMeter.idDistributor = this.userSession.getLoggedOperator().idDistributor

            this.meterService
                .saveMeter(opMeter, true)
                .then((savedMeter: OpMeter) => {
                    opDevice.currentMeters.push(savedMeter)

                    const device: OpDevice = new OpDevice(null)
                    device.serialNbr = opDevice.serialNbr
                    device.opState = Enums.OpChangeState.New

                    const meter: OpMeter = new OpMeter(null)
                    meter.idMeter = savedMeter.idMeter
                    meter.opState = Enums.OpChangeState.New

                    meter.currentDevices.push(device)
                    meter.currentDevicesDict = new Dictionary<OpDevice>([])
                    meter.currentDevicesDict.add(device.serialNbr, device)

                    const location: OpLocation = new OpLocation(null)
                    location.idLocation = locationToSave.idLocation
                    location.opState = Enums.OpChangeState.New

                    meter.currentLocations.push(location)
                    meter.currentLocationsDict = new Dictionary<OpLocation>([])
                    meter.currentLocationsDict.add(location.idLocation, location)

                    locationToSave.currentMeters.push(meter)
                    locationToSave.currentMetersDict = new Dictionary<OpMeter>([])
                    locationToSave.currentMetersDict.add(meter.idMeter, meter)

                    locationToSave.currentDevices.forEach((dev: OpDevice) => {
                        if (dev.serialNbr === opDevice.serialNbr) {

                            const met: OpMeter = new OpMeter(null)
                            met.idMeter = savedMeter.idMeter
                            met.opState = Enums.OpChangeState.New

                            dev.currentMeters.push(met)
                            dev.currentMetersDict = new Dictionary<OpMeter>([])
                            dev.currentMetersDict.add(met.idMeter, met)
                        }
                    })

                    promise.resolve()
                    return promise.promise()
                })
                .catch((error: any) => {
                    this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                    ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
                    defer.reject()
                })
        } else {
            if (opDevice != null) {
                if (locationToSave.currentMetersDict == null) {
                    locationToSave.currentMetersDict = new Dictionary<OpMeter>([])
                }

                opDevice.currentMeters.forEach((meter: OpMeter) => {
                    const index: number = _.findIndex(locationToSave.currentMeters, (met: OpMeter) => met.idMeter === meter.idMeter)
                    if (index === -1) {
                        locationToSave.currentMeters.push(meter)
                        locationToSave.currentMetersDict.add(meter.idMeter, meter)
                    } else {
                        locationToSave.currentMeters[index] = meter
                        locationToSave.currentMetersDict[meter.idMeter] = meter
                    }
                })
            }
            promise.resolve()
        }

        $.when(promise).then(() => {
            this.saveLocation(locationToSave, null, false).then((savedLocation: IOpObject) => {
                if (opDevice != null) {
                    opDevice.opState = Enums.OpChangeState.Loaded
                    this.deviceService
                        .saveDevice(this.userSession.getDataProvider(), opDevice, Enums.SimaxModuleName.Device, true)
                        .then((devedDevice: OpDevice) => {

                            if (opDevice.dataList.toArray().some((data: OpData) => data.opState !== Enums.OpChangeState.Loaded)) {
                                this.askRunAction()
                            }

                            defer.resolve(savedLocation)
                        })
                        .fail((error: any) => {
                            defer.reject(error)
                        })
                } else {
                    defer.resolve(savedLocation)
                }
            })
        })

        return defer.promise
    }

    //#endregion
}